import { controls, currencyToNumber, grouped, where_pending } from "../../controls";

const suspicious_trn_taluka= {
  label: "suspicious Transactions Takuka",
  starting: true,
  url: "suspicious_trn_taluka",
  pageLabel: "suspicious Transactions Taluka",
  pageType: "history",
  // filteraction: true,
  filter: [
       ...controls.displayText({ tab: "filter", label: "Repeat count"}),
       ...controls.text({ tab: "filter",  placeHolder: "", name: "repeat_count"}),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "suspicious Transactions Account no",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pivotable: true,
     charts: {
     pie: {
         row: { targetfield: 'account_no', flabel: 'account_no' },
         column: { targetrow: 'account_no' },
    //       // colors:[...Array(100).keys()].map(r=>chroma.random())
       }
       },
      // pivot:true,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      location: "top",
      fields: ["total_amount"],
      subtotals: {
        by: "taluka_display",
        displayIn: "account_no",
      
      },
     grandtotal: { type: "fixed", displayIn: "uploaded_name", val: "Grand Total", count: true },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      // {
      //   Header: "Branch",
      //   accessor: "branch_display",
      //   rwidth: "*"
      // },
      {
        Header: "Account no",
        accessor: "account_no"
      },
      {
        Header: "Name",
        accessor: "account_name",
        
      },
   
      {
        Header: "Uploaded name",
        accessor: "uploaded_name"
      },
      {
        Header: "Amount",
        accessor: "total_amount",
        type:"currency"
      },
      {
        Header: "Talathi name",
        accessor: "talathi_name",
       
      },
      {
        Header: "mobile no",
        accessor: "mobile"
      },
      {
        Header: "Taluka display",
        accessor: "taluka_display",
      
      },
      {
        Header: "Village display",
        accessor: "village_display",
      
      },

    ]
  }
};

export default suspicious_trn_taluka;